import { defineComponent as i, openBlock as a, createBlock as c, unref as r, mergeProps as n, withCtx as o, renderSlot as f } from "vue";
import k from "./ghl-ui.es258.js";
import s from "./ghl-ui.es259.js";
const u = i({
  name: "UICheckbox",
  inheritAttrs: !1
}), b = i({
  ...u,
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    checked: {
      type: Boolean,
      default: !1
    },
    id: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: "default"
    },
    src: {
      type: String,
      default: ""
    },
    fallbackSrc: {
      type: String,
      default: ""
    }
  },
  emits: ["update:checked", "onSelect"],
  setup(e) {
    return (t, d) => e.type === "image" ? (a(), c(k, {
      key: 0,
      id: e.id,
      src: e.src,
      fallbackSrc: e.fallbackSrc,
      checked: e.checked,
      disabled: e.disabled,
      onOnSelect: d[0] || (d[0] = (l) => t.$emit("onSelect", l))
    }, null, 8, ["id", "src", "fallbackSrc", "checked", "disabled"])) : (a(), c(r(s), n({
      key: 1,
      id: e.id,
      disabled: e.disabled
    }, t.$attrs, {
      checked: e.checked,
      size: "large",
      "onUpdate:checked": d[1] || (d[1] = (l) => t.$emit("update:checked", l))
    }), {
      default: o(() => [
        f(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "disabled", "checked"]));
  }
}), y = b;
export {
  y as default
};
